const activeBlockType = (editor) => (editor.isActive('heading') ? 'heading' : 'paragraph');

const getCurrentMargin = (editor, side) => {
  const margin = editor.getAttributes(activeBlockType(editor)).margin || {};
  return parseInt(margin[side], 10) || 0;
};

const setMarginTop = (editor, { value }) => {
  const top = Math.max(0, parseInt(value, 10) || 0);
  editor
    .chain()
    .focus()
    .setMargin({ top: `${top}px` })
    .run();
};

const unsetMarginTop = (editor) => {
  editor.chain().focus().setMargin({ top: '0px' }).run();
};

const increaseMarginTop = (editor) => {
  const top = getCurrentMargin(editor, 'top') + 1;
  editor
    .chain()
    .focus()
    .setMargin({ top: `${top}px` })
    .run();
};

const decreaseMarginTop = (editor) => {
  const top = Math.max(0, getCurrentMargin(editor, 'top') - 1);
  editor
    .chain()
    .focus()
    .setMargin({ top: `${top}px` })
    .run();
};

const setMarginBottom = (editor, { value }) => {
  const bottom = Math.max(0, parseInt(value, 10) || 0);
  editor
    .chain()
    .focus()
    .setMargin({ bottom: `${bottom}px` })
    .run();
};

const unsetMarginBottom = (editor) => {
  editor.chain().focus().setMargin({ bottom: '0px' }).run();
};

const increaseMarginBottom = (editor) => {
  const bottom = getCurrentMargin(editor, 'bottom') + 1;
  editor
    .chain()
    .focus()
    .setMargin({ bottom: `${bottom}px` })
    .run();
};

const decreaseMarginBottom = (editor) => {
  const bottom = Math.max(0, getCurrentMargin(editor, 'bottom') - 1);
  editor
    .chain()
    .focus()
    .setMargin({ bottom: `${bottom}px` })
    .run();
};

export default {
  'margin:top:set': setMarginTop,
  'margin:top:unset': unsetMarginTop,
  'margin:top:increase': increaseMarginTop,
  'margin:top:decrease': decreaseMarginTop,
  'margin:bottom:set': setMarginBottom,
  'margin:bottom:unset': unsetMarginBottom,
  'margin:bottom:increase': increaseMarginBottom,
  'margin:bottom:decrease': decreaseMarginBottom,
};
